import { render } from "./SideBarProfile.vue?vue&type=template&id=25be9037"
import script from "./SideBarProfile.vue?vue&type=script&lang=js"
export * from "./SideBarProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__